import { MapSettings as View } from 'ui-components'
import { General } from './General'
import { InfoPanel } from './InfoPanel'

export const MapSettings = (props) => {
  return (
    <View
      onTabChange={props.onTabChange}
      activeTab={props.activeTab || 'general'}
      slots={{ General, InfoPanel }}
      slotProps={{}}
    />
  )
}
